/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultListServers } from "../../funcs/llmMcpVaultListServers.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListMcpServersRequest$inboundSchema,
};

export const tool$llmMcpVaultListServers: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-list-servers",
  description: `List MCP servers

Lists MCP server configurations owned by the authenticated user context.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultListServers(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
